/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateInternetPackageRequest } from '../models/create-internet-package-request';
import { GenericResponse } from '../models/generic-response';
import { GetInternetPackageResponse } from '../models/get-internet-package-response';
import { InternetPackageResponse } from '../models/internet-package-response';
import { UpdateInternetPackageRequest } from '../models/update-internet-package-request';

/**
 * Internet package master APIs
 */
@Injectable({ providedIn: 'root' })
export class InternetPackageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllInternetPackage()` */
  static readonly GetAllInternetPackagePath = '/api/v1/internet-packages';

  /**
   * Get list of internet packages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllInternetPackage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllInternetPackage$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * search internet package name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetInternetPackageResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      InternetPackageService.GetAllInternetPackagePath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetInternetPackageResponse>;
        })
      );
  }

  /**
   * Get list of internet packages.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllInternetPackage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllInternetPackage(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * search internet package name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetInternetPackageResponse> {
    return this.getAllInternetPackage$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetInternetPackageResponse>
        ): GetInternetPackageResponse => r.body
      )
    );
  }

  /** Path part for operation `createInternetPackage()` */
  static readonly CreateInternetPackagePath = '/api/v1/internet-packages';

  /**
   * Create internet package.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createInternetPackage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInternetPackage$Response(
    params: {
      body: CreateInternetPackageRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<InternetPackageResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      InternetPackageService.CreateInternetPackagePath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<InternetPackageResponse>;
        })
      );
  }

  /**
   * Create internet package.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createInternetPackage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createInternetPackage(
    params: {
      body: CreateInternetPackageRequest;
    },
    context?: HttpContext
  ): Observable<InternetPackageResponse> {
    return this.createInternetPackage$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<InternetPackageResponse>
        ): InternetPackageResponse => r.body
      )
    );
  }

  /** Path part for operation `getInternetPackageById()` */
  static readonly GetInternetPackageByIdPath = '/api/v1/internet-packages/{id}';

  /**
   * Get internet package by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInternetPackageById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInternetPackageById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<InternetPackageResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      InternetPackageService.GetInternetPackageByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<InternetPackageResponse>;
        })
      );
  }

  /**
   * Get internet package by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInternetPackageById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInternetPackageById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<InternetPackageResponse> {
    return this.getInternetPackageById$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<InternetPackageResponse>
        ): InternetPackageResponse => r.body
      )
    );
  }

  /** Path part for operation `deleteInternetPackage()` */
  static readonly DeleteInternetPackagePath = '/api/v1/internet-packages/{id}';

  /**
   * Delete internet package by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteInternetPackage()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInternetPackage$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      InternetPackageService.DeleteInternetPackagePath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete internet package by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteInternetPackage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInternetPackage(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteInternetPackage$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateInternetPackage()` */
  static readonly UpdateInternetPackagePath = '/api/v1/internet-packages/{id}';

  /**
   * Update internet package by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateInternetPackage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInternetPackage$Response(
    params: {
      id: number;
      body: UpdateInternetPackageRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<InternetPackageResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      InternetPackageService.UpdateInternetPackagePath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<InternetPackageResponse>;
        })
      );
  }

  /**
   * Update internet package by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateInternetPackage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateInternetPackage(
    params: {
      id: number;
      body: UpdateInternetPackageRequest;
    },
    context?: HttpContext
  ): Observable<InternetPackageResponse> {
    return this.updateInternetPackage$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<InternetPackageResponse>
        ): InternetPackageResponse => r.body
      )
    );
  }
}
